import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from "./errorBoundary/ErrorBoundary";
import {ThemeContextProvider} from "./infrastructure/ThemeContext";
import {UserContextProvider} from "./infrastructure/UserContext";
import {ServiceContextProvider} from "./infrastructure/ServiceContextProvider";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <ErrorBoundary>
            <ServiceContextProvider>
                <ThemeContextProvider>
                    <UserContextProvider>
                        <App/>
                    </UserContextProvider>
                </ThemeContextProvider>
            </ServiceContextProvider>
        </ErrorBoundary>
    </BrowserRouter>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();